import * as R from "ramda";

import actionTypes from "../actionTypes";
import initialState from "./initialState";

export default function (state = initialState.corpMenu, action) {
  switch (action.type) {
    case actionTypes.LOAD_CORP_MENUS:
      return {
        result: action.result,
        entities: action.entities,
        loading: false,
      };
    case actionTypes.LOAD_CORP_MENU:
      return {
        result: R.uniq(R.append(action.corpMenuId, state.result)),
        entities: R.assocPath(["corpMenu", action.corpMenuId], action.corpMenu, state.entities),
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/corpMenu.js